import Immutable from 'seamless-immutable';
import { ADD_FULFILMENT_START, ADD_FULFILMENT_SUCCESS, ADD_FULFILMENT_ERROR } from '../Actions/AddFulfilment';

const initialState = Immutable({
    fetching: false,
    success: false,
    error: null
});

export default function addFulfilmentReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_FULFILMENT_START:
            return Immutable.merge(state, {
                fetching: true,
                success: false,
                error: null
            });
        case ADD_FULFILMENT_SUCCESS:
            return Immutable.merge(state, {
                fetching: false,
                success: true,
                error: null
            });
        case ADD_FULFILMENT_ERROR:
            return Immutable.merge(state, {
                fetching: false,
                success: false,
                error: action.payload.error
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/AddFulfilmentReducer.js